import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useSelector } from 'react-redux';
import { Loader } from 'components/loader/loader';
import { css } from 'linaria';
const loadMoreStyle = "ljv1j08";
const loadMoreRefStyle = "l1imbxcz";
export function LoadMore({
  loadMore
}) {
  const {
    ref,
    inView
  } = useInView();
  const hasNextPage = useSelector(state => state.listSavedPageInfo.hasNextPage);
  const loading = useSelector(state => state.listSavedPageInfo.loading);
  const error = useSelector(state => state.listSavedPageInfo.error);
  const listSaved = useSelector(state => state.listSaved);
  const shouldLoadMore = hasNextPage && !loading;
  const loadMoreMessage = listSaved.length ? 'Loading more items' : '';
  useEffect(() => {
    if (!inView) return; // There are more items to load! Let's do it

    if (shouldLoadMore) loadMore();
  }, [inView, loadMore, shouldLoadMore]);
  return loading || error ? <div key="load-more" className={loadMoreStyle}>
      {error ? <>Something went wrong while retrieving your items</> : <>
          {loadMoreMessage} <Loader />
        </>}
    </div> : <div ref={ref} className={loadMoreRefStyle} />;
}

require("./load-more.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./load-more.js");